<template>
    <div class="comp">
        <el-dialog :title="type == 'add' ? '新增' : '编辑'" :visible.sync="visible" width="40%" @close='close' center>
            <div style="display: flex;justify-content: space-around;">
                <div class="dialogContent">
                    <div>上级菜单:</div>
                    <el-input v-if="father_info"  v-model="father_info.title" :disabled="true" placeholder="请输入"
                        size="small"></el-input>
                        <el-input v-if="!father_info"  :disabled="true" placeholder="请输入"
                        size="small"></el-input>
                </div>
                <div class="dialogContent">
                    <div>菜单类型:</div>
                    <el-radio-group v-model="menu_type" :disabled="falg">
                        <el-radio  :label="1">菜单</el-radio>
                        <el-radio  :label="2">功能页面</el-radio>
                        <el-radio   :label="3">按钮</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div style="display: flex;justify-content: space-around;">
                <div class="dialogContent">
                    <div>菜单名称:</div>
                    <el-input v-model="title" placeholder="请输入菜单名称" size="small"></el-input>
                </div>
                <div class="dialogContent">
                    <div>显示排序:</div>
                    <el-input v-model="order" placeholder="请输入排序" size="small"></el-input>
                </div>
            </div>
            <div style="display: flex;justify-content: space-around;align-items: center;line-height: 30px;">
                <div class="dialogContent" style="display: flex;margin: 10px 0;">
                    <div>编码:</div>
                    <div>{{ father_info ? father_info.code : '--' }}</div>
                </div>
                <div class="dialogContent">
                    <el-input :disabled="falg" v-model="code" placeholder="请输入编码" size="small"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="btn2" @click="close">取消</div>
                <div class="btn" @click="submit">确定</div>
            </span>
        </el-dialog>

    </div>
</template>
<script>
export default {
    data() {
        return {
            visible: true,
            title: "",
            code: "",
            icon: "",
            order:null,
            system_info: {},
            father_info:{},
            menu_type:'',
            falg:true,
            ocode:'',
            oldcode:'',
            oldfather_info:{}
        }
    },

    props: {
        row: {
            default: () => {
                return {}
            }
        },
        type: {
            default: ''
        },
    },
    watch: {
        dialogUpdateStates(n) {
            this.$emit('close', n)
        }
    },
    mounted() {
        if (this.type == 'edit') {
           this.falg=true,
            this.title=this.row.title,
            this.ocode=this.row.code,
            this.code=this.row.code.slice(this.row.code.lastIndexOf("-") + 1),
            this.icon=this.row.icon,
            this.order=this.row.order,
            this.system_info=this.row.system_info,
            this.father_info=this.row.father_info,
            this.menu_type=this.row.menu_type
        }else{
            this.falg=false
            this.father_info={
           code:this.row.code,
            title:this.row.title
        }
        this.system_info=this.row.system_info,
        this.oldfather_info=this.father_info
        //    this.oldfather_info.push(this.father_info)
            this.oldcode=this.row.code
        }



    },
    methods: {
        close() {
            this.$emit("submit", {
                type: 'close'
            });
        },

        // 确定按钮关闭 编辑菜单弹框
        submit() {
            if (this.title =='') {
				this.$message({
					type: "error",
					message: "请输入名称",
				});
				return;
			} 
      if (this.menu_type =='') {
				this.$message({
					type: "error",
					message: "请输入菜单类型",
				});
				return;
			}
            let params = {
                title: this.title,
                icon: this.icon,
                order: this.order,
              
            }
           if(this.type=='edit'){
            params.code=this.ocode
            params.systemCode=this.system_info.code,
            
            this.$http.post(process.env.VUE_APP_zichan + '/api/SystemRights/menu/update',params).then(res => {
            	if (res.code == 0) {
                this.$message({
            				type: 'success',
            				message: '已更新'
            			})
                        this.title='',
                        this.icon='',
                        this.order='',
                        this.$emit("submit", {
								type: 'success'
							});

            	}
            })
           }else if(this.type=='add'){
            params.code=this.oldcode+'-'+this.code,
            params.system_info=this.system_info,
            params.father_info=this.oldfather_info,
            params.menu_type=this.menu_type
            this.$http.post(process.env.VUE_APP_zichan + '/api/SystemRights/menu/add',params).then(res => {
						if (res.code == 0) {
              this.$message({
									type: 'success',
									message: '已新增'
								})
                                this.title='',
                        this.icon='',
                        this.order='',
                                this.$emit("submit", {
								type: 'success'
							});
						}
					})
           }
         
        },
    }
}
</script>
<style lang="scss" scoped>
.comp {

    // ::v-deep .el-dialog__title{
    //     width: 100% !important;
    //     padding: 10px 10%;
    //     background-color: #F5882A !important;
    // }
    .dialogContent {
        width: 250px;

        div {
            padding: 5px 0;
        }
    }

    .dialog-footer {
        display: flex;
        justify-content: space-evenly;


        .btn {
            width: 98px;
            line-height: 40px;
            text-align: center;
            background: linear-gradient(135deg, #F5882A 0%, #F5882A 100%);
            border-radius: 10px;
            font-size: 16px;
            font-weight: bold;
            color: #fff;
            cursor: pointer;
            margin-left: 20px;
        }

        .btn2 {
            width: 98px;
            line-height: 40px;
            text-align: center;
            border-radius: 10px;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            box-sizing: border-box;
            border: solid 1px #F5882A;
            color: #F5882A;
        }
    }
}</style>
